import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBZuYfjHXmg4R7wmsJtPZHMjYXcQTCSV64",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "quotehaul-b25f5.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "quotehaul-b25f5",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "quotehaul-b25f5.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "200440032675",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:200440032675:web:f1385deebe1179ab397e16",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-FBX7BPSXV7"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Analytics fallback for SSR / test environments
export let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch(() => {});

export default app;
